export const EDITOR_TYPES = Object.freeze({
    QUESTIONNAIRE: "questionnaire",
    CATEGORY: "category",
    GROUP: "group",
    QUESTION: "question",
    ACTION: "action"
});

const sessionId = Date.now().toString(36);
let nextInstanceId = 0;

export function createEditorInstanceId(editorType, depth = 0) {
    nextInstanceId += 1;
    return `${editorType}:${depth}:${sessionId}:${nextInstanceId}`;
}

export function createEditorOrigin(editorType, instanceId, depth = 0) {
    if (!instanceId) {
        return null;
    }
    return {
        editorType,
        instanceId,
        ...(editorType === EDITOR_TYPES.QUESTION ? {depth} : {})
    };
}

export function captureEditorOrigin(origin) {
    return origin ? {...origin} : null;
}

export function editorOriginMatches(origin, editorType, editorState, depth = 0) {
    return Boolean(
        origin
        && editorState?.instanceId
        && origin.editorType === editorType
        && origin.instanceId === editorState.instanceId
        && (editorType !== EDITOR_TYPES.QUESTION || origin.depth === depth)
    );
}

export function activeEditorOriginMatches(origin, state) {
    if (!origin) {
        return false;
    }
    switch (origin.editorType) {
        case EDITOR_TYPES.QUESTIONNAIRE:
            return editorOriginMatches(origin, EDITOR_TYPES.QUESTIONNAIRE, state.questionnaireEditor);
        case EDITOR_TYPES.CATEGORY:
            return editorOriginMatches(origin, EDITOR_TYPES.CATEGORY, state.categoryEditor);
        case EDITOR_TYPES.GROUP:
            return editorOriginMatches(origin, EDITOR_TYPES.GROUP, state.groupEditor);
        case EDITOR_TYPES.QUESTION:
            return editorOriginMatches(
                origin,
                EDITOR_TYPES.QUESTION,
                state.questionEditor?.[origin.depth],
                origin.depth
            );
        case EDITOR_TYPES.ACTION:
            return editorOriginMatches(origin, EDITOR_TYPES.ACTION, state.actionEditor);
        default:
            return false;
    }
}

export function runIfEditorOwnerActive(getState, owner, operation) {
    if (!owner || activeEditorOriginMatches(owner, getState())) {
        operation();
        return true;
    }
    return false;
}

export function questionEditorAnswerTargetMatches(origin, state, answerIndex) {
    if (origin?.editorType !== EDITOR_TYPES.QUESTION) {
        return true;
    }
    if (!Number.isInteger(answerIndex) || answerIndex < 0) {
        return false;
    }
    const questionEditor = state.questionEditor?.[origin.depth];
    return editorOriginMatches(
        origin,
        EDITOR_TYPES.QUESTION,
        questionEditor,
        origin.depth
    ) && Boolean(questionEditor.answerOptionTemplates?.[answerIndex]);
}
